import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e3b902e4")

_pushScopeId("data-v-e3b902e4")
const _hoisted_1 = { class: "the-loading-message" }
const _hoisted_2 = { class: "the-loading-message-contents" }
const _hoisted_3 = { class: "the-loading-message-contents-message" }
const _hoisted_4 = { class: "the-loading-message-contents-message-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.loadingMessageText), 1)
      ])
    ])
  ]))
})